import { render, staticRenderFns } from "./ProductFiles.vue?vue&type=template&id=240f4c08&scoped=true&"
import script from "./ProductFiles.vue?vue&type=script&lang=js&"
export * from "./ProductFiles.vue?vue&type=script&lang=js&"
import style0 from "./ProductFiles.vue?vue&type=style&index=0&id=240f4c08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f4c08",
  null
  
)

export default component.exports